<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="checkDialogFormVisible({}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
    >
      <el-table-column prop="id" label="编号" sortable width="100"> </el-table-column>

      <el-table-column align="center" prop="levelName" label="等级名称" sortable> </el-table-column>
      <el-table-column align="center" prop="ratio" label="优惠比例" width="90"> </el-table-column>

      <el-table-column align="center" prop="ctdate" label="创建时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="更新时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="100"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="checkDialogFormVisible(scope.row, 'UPDATE')"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑 -->
    <el-dialog
      :visible.sync="enterpriseConfigDialogVisible"
      :title="enterpriseConfigData.id ? '编辑企业用户配置' : '新增企业用户配置'"
    >
      <el-form :model="enterpriseConfigData">
        <el-form-item label="等级名称">
          <el-input v-model="enterpriseConfigData.levelName" placeholder="请输入" size="small" />
        </el-form-item>
        <el-form-item label="优惠比例">
          <el-input
            v-model="enterpriseConfigData.ratio"
            type="number"
            size="small"
            :max="1"
            :min="0"
            :step="0.01"
            :precision="2"
            placeholder="比例: 0.5=5折"
            @input="handleInput"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="enterpriseConfigDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getEnterpriseConfigLevel, editEnterpriseConfigLevel } from "@/api/system.js";
import { getValue, UPGRADES_CONDITIONS } from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    },
    UPGRADES_CONDITIONS() {
      return UPGRADES_CONDITIONS;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {},
      enterpriseConfigDialogVisible: false,
      enterpriseConfigData: {}
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getEnterpriseConfigLevel(this.listQuery)
        .then(response => {
          this.list = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    saveData() {
      this.btnLoading = true;
      console.log("新增/编辑--保存", this.enterpriseConfigData);
      editEnterpriseConfigLevel(this.enterpriseConfigData)
        .then(() => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.enterpriseConfigDialogVisible = false;
          this.getList();
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    /**
     * 新增/编辑
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(editObj = {}) {
      console.log("新增/编辑", editObj);
      this.enterpriseConfigData = editObj;
      this.enterpriseConfigDialogVisible = true;
    },
    handleInput(value) {
      // 确保值在 0-1 范围内
      if (value > 1) {
        this.enterpriseConfigData.ratio = 1;
      } else if (value < 0) {
        this.enterpriseConfigData.ratio = 0;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
